var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          ref: "modal_workers_select",
          attrs: {
            id: "modal-workers",
            title: _vm.title,
            "content-class": "modal-fullscreen",
            "body-class": "modal-body-fullscreen",
            "modal-class": "custom-modal",
            "no-close-on-esc": "",
            "no-close-on-backdrop": "",
            scrollable: ""
          },
          on: { hidden: _vm.onHidden },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c(
                    "div",
                    { staticClass: "w-100 d-flex justify-content-end" },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "custom-btn-secondary mr-2",
                          on: { click: _vm.hideModal }
                        },
                        [_vm._v("\n          Отменить\n        ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "custom-btn-primary",
                          attrs: { disabled: _vm.isBusy },
                          on: { click: _vm.rowClickHandler }
                        },
                        [_vm._v("\n          Добавить в заявку\n        ")]
                      )
                    ],
                    1
                  )
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c(
            "b-row",
            { staticClass: "mb-0" },
            [
              _c(
                "b-col",
                { attrs: { cols: "10" } },
                [
                  _c("b-form", [
                    _c(
                      "div",
                      { staticClass: "page-body" },
                      [
                        _c("div", { staticClass: "page-filters" }, [
                          _c(
                            "div",
                            { staticClass: "d-flex align-items-center" },
                            [
                              _c(
                                "div",
                                { staticClass: "flex-grow-1" },
                                [
                                  _c(
                                    "b-input-group",
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          size: "sm",
                                          placeholder: _vm.$t(
                                            "message.common.search"
                                          )
                                        },
                                        on: { input: _vm.onInput },
                                        model: {
                                          value: _vm.query,
                                          callback: function($$v) {
                                            _vm.query = $$v
                                          },
                                          expression: "query"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("b-input-group-append", [
                                        _c(
                                          "button",
                                          {
                                            staticClass: "search-btn",
                                            attrs: { type: "button" },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.onSearch()
                                              }
                                            }
                                          },
                                          [
                                            _c("v-icon", {
                                              attrs: { name: "buttons/search" }
                                            })
                                          ],
                                          1
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                [
                                  _c(
                                    "b-form-select",
                                    {
                                      staticClass: "ml-3",
                                      attrs: { id: "input-town", size: "sm" },
                                      on: {
                                        change: function($event) {
                                          return _vm.onTownChange()
                                        }
                                      },
                                      model: {
                                        value: _vm.currentTown,
                                        callback: function($$v) {
                                          _vm.currentTown = $$v
                                        },
                                        expression: "currentTown"
                                      }
                                    },
                                    [
                                      _c(
                                        "option",
                                        { domProps: { value: -1 } },
                                        [_vm._v("Все города")]
                                      ),
                                      _vm._v(" "),
                                      _vm._l(_vm.towns, function(option) {
                                        return _c(
                                          "option",
                                          {
                                            key: option.id,
                                            domProps: { value: option.id }
                                          },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(option.name) +
                                                "\n                    "
                                            )
                                          ]
                                        )
                                      })
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _vm.isBusy || (_vm.items && _vm.items.length > 0)
                          ? [
                              _c(
                                "div",
                                { staticClass: "page-table-container" },
                                [
                                  _c("b-table", {
                                    staticClass: "custom-table text-small mb-0",
                                    attrs: {
                                      id: "workers",
                                      responsive: "",
                                      busy: _vm.isBusy,
                                      items: _vm.items,
                                      fields: _vm.fields,
                                      "tbody-tr-class": _vm.tbodyRowClass,
                                      "no-provider-filtering": "",
                                      "no-provider-paging": "",
                                      "no-provider-sorting": ""
                                    },
                                    on: { "row-clicked": _vm.rowClicked },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "table-busy",
                                          fn: function() {
                                            return [
                                              _c("tables-skeleton", {
                                                attrs: {
                                                  fields: _vm.fields,
                                                  rows: 5
                                                }
                                              })
                                            ]
                                          },
                                          proxy: true
                                        },
                                        {
                                          key: "cell(phone)",
                                          fn: function(row) {
                                            return [
                                              _c(
                                                "a",
                                                {
                                                  staticStyle: {
                                                    color: "#1A9167 !important"
                                                  },
                                                  attrs: {
                                                    href: _vm.telUrl(
                                                      row.item.phone
                                                    )
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.phoneString(
                                                        row.item.phone
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          }
                                        },
                                        {
                                          key: "cell(passport_url)",
                                          fn: function(row) {
                                            return [
                                              row.item.passport_url.length > 0
                                                ? _c(
                                                    "a",
                                                    {
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.downloadFile(
                                                            row.item.id,
                                                            row.item
                                                              .passport_url
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("v-icon", {
                                                        style: {
                                                          color: "#1A9167"
                                                        },
                                                        attrs: {
                                                          name:
                                                            "buttons/passport",
                                                          size: 19
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            ]
                                          }
                                        },
                                        {
                                          key: "cell(level_efficiency)",
                                          fn: function(row) {
                                            return [
                                              _c(
                                                "span",
                                                {
                                                  class: [
                                                    "custom-tag",
                                                    _vm.getLevelEfficiencyStyle(
                                                      row.item.level_efficiency
                                                    )
                                                  ],
                                                  attrs: {
                                                    id:
                                                      "level-efficiency-badge-" +
                                                      row.item.id
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm.getLevelEfficiencyText(
                                                          row.item
                                                            .level_efficiency
                                                        )
                                                      ) +
                                                      "\n                    "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              row.item.description !== ""
                                                ? _c(
                                                    "b-tooltip",
                                                    {
                                                      attrs: {
                                                        target:
                                                          "level-efficiency-badge-" +
                                                          row.item.id,
                                                        triggers: "hover",
                                                        variant: _vm.getLevelEfficiencyStyle(
                                                          row.item
                                                            .level_efficiency
                                                        ),
                                                        noninteractive: ""
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            row.item.description
                                                          ) +
                                                          "\n                    "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          }
                                        },
                                        {
                                          key: "cell(employment_type)",
                                          fn: function(row) {
                                            return [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.getEmploymentTypeText(
                                                      row.item.employment_type
                                                    )
                                                  ) +
                                                  "\n                  "
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      2928986125
                                    )
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "page-pagination" },
                                [
                                  _c("pagination-footer", {
                                    attrs: {
                                      "total-rows": _vm.totalRows,
                                      "per-page": _vm.perPage,
                                      "current-page": _vm.currentPage
                                    },
                                    on: {
                                      "page-change": _vm.onPageChange,
                                      "per-page-change": _vm.onPerPageChange
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "footer-list",
                                          fn: function() {
                                            return [
                                              _c("div", [
                                                _vm._v(
                                                  "\n                      Всего исполнителей: "
                                                ),
                                                _c("b", [
                                                  _vm._v(_vm._s(_vm.totalRows))
                                                ])
                                              ])
                                            ]
                                          },
                                          proxy: true
                                        },
                                        {
                                          key: "footer-per-page",
                                          fn: function() {
                                            return [_c("span")]
                                          },
                                          proxy: true
                                        }
                                      ],
                                      null,
                                      false,
                                      1194332357
                                    )
                                  })
                                ],
                                1
                              )
                            ]
                          : _c(
                              "div",
                              { staticClass: "empty-state-container" },
                              [
                                _c("v-icon", {
                                  attrs: {
                                    name: "navbar/empty_table",
                                    size: 90
                                  }
                                }),
                                _vm._v(" "),
                                _c("h5", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.isFiltered
                                        ? "Нет данных соответствующих фильтрам."
                                        : "Нет добавленных исполнителей."
                                    )
                                  )
                                ])
                              ],
                              1
                            )
                      ],
                      2
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("b-col", { attrs: { cols: "2" } }, [
                _c(
                  "div",
                  { staticClass: "sticky-info" },
                  [
                    _c("h6", [
                      _vm._v(
                        "Будут добавлены: " + _vm._s(_vm.selectedItems.length)
                      )
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.selectedItems, function(item, index) {
                      return _c("div", { key: item.id }, [
                        _c("small", [_vm._v(_vm._s(item.name))])
                      ])
                    }),
                    _vm._v(" "),
                    _c("hr"),
                    _vm._v(" "),
                    _c("h6", [
                      _vm._v("Уже в заявке: " + _vm._s(_vm.tws.length))
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.tws, function(item, index) {
                      return _c("div", { key: item.id }, [
                        _c("small", [_vm._v(_vm._s(item.name))])
                      ])
                    })
                  ],
                  2
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-478dd8c7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-478dd8c7","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!/home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Workers/WorkersFree.vue
// module id = null
// module chunks = 